export class CategoryType { 
    public key: string;
    public name: string
    public sortOrder: number
    public isModelCategory: boolean

    constructor({ key, name, sortOrder, isModelCategory } : { key: string, name: string, sortOrder?: number, isModelCategory?: boolean }) {
        this.key = key;
        this.name = name;
        this.sortOrder = sortOrder;
        this.isModelCategory = isModelCategory;
    }
}